import type { AxiosRequestConfig, AxiosResponse } from "axios";
import axios from "axios";
import _ from "lodash";
const apiBase = axios.create({});

const _get = apiBase.get;
apiBase.defaults.baseURL = process.env.REACT_APP_API_URL || "";
apiBase.get = function <T = any, R = AxiosResponse<T, any>, D = any>(
  url: string,
  config?: AxiosRequestConfig<D>,
): Promise<R> {
  return _get(url, config).then(
    (response: AxiosResponse<T>) => response as unknown as R,
  );
};

apiBase.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    const LSKey = `oidc.user:${process.env.REACT_APP_AZURE_AUTHORITY}:${process.env.REACT_APP_AZURE_CLIENTID}`;

    const tokenData = localStorage.getItem(LSKey) || "";
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${
      JSON.parse(tokenData).access_token
    }`;
    config.params = config.params || {};
    if (config.method === "get") {
      _.forOwn(config.params, (value, key) => {
        config.params[key] = value;
      });
    }
    return config;
  },
  (error: any) => Promise.reject(error),
);

apiBase.interceptors.response.use(
  (response: AxiosResponse<any>) => response.data,
  (error: any) => Promise.reject(error),
);

export { type AxiosRequestConfig, type AxiosResponse,apiBase as default };
